import { useEffect } from 'react';

export const useBodyClass = (classNames: string[]) => {
  useEffect(() => {
    classNames.forEach(className => document.body.classList.add(className));

    return () => {
      classNames.forEach(className => document.body.classList.remove(className));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [classNames.join(' ')]);
};
